import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { Tooltip } from "react-tooltip";
import { getDailyNotificationActivityLogs } from "../../modules/Notification";
import { showSpinner, closeSpinner, modal, alert } from "../../modules/Dialogs";
import { sessionExpired } from "../../config/GeneralConfig";
import { toScreen } from "../../modules/Routing";

const COLUMNS = [
  { key: "date",        label: "Date",         class: "c-list-entry__mavname", sortable: false },
  { key: "activityKey", label: "Activity Key", class: "c-list-entry__rating",  sortable: false },
  { key: "channel",     label: "Channel",      class: "c-list-entry__reason",  sortable: false },
  { key: "sent",        label: "Sent",         class: "c-list-entry__mavjobs", sortable: false },
  { key: "delivered",   label: "Delivered",    class: "c-list-entry__mavjobs", sortable: false },
  { key: "failed",      label: "Failed",       class: "c-list-entry__mavjobs", sortable: false },
  { key: "abandoned",   label: "Abandoned",    class: "c-list-entry__mavjobs", sortable: false },
  { key: "rate",        label: "Rate",         class: "c-list-entry__mavjobs", sortable: false },
];

const CHANNEL_BADGE = {
  email: "badge-orange",
  push: "badge-info",
};
const DailySummaryTab = ({ userDetails, navigate }) => {
  const [data, setData]         = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(() => {
    showSpinner();
    setIsLoading(true);

    getDailyNotificationActivityLogs(
      {},
      (resStatus, responseString, resJson) => {
        closeSpinner();
        setIsLoading(false);

        if (resStatus === 401) {
          modal(sessionExpired);
          toScreen(false, navigate, "/logout");
        } else if (resStatus === "400") {
          setData([]);
          alert(responseString);
        } else if (resStatus === 200 || resStatus === "200") {
          const fetched = resJson?.payload || resJson?.data || [];
          if (Array.isArray(fetched) && fetched.length > 0) {
            const processed = fetched.map((item, idx) => {
              const delivered = item.delivered || 0;
              const failed    = item.failed || item.totalFailed || 0;
              const abandoned = item.abandoned || item.totalAbandoned || 0;
              const rate      = delivered > 0
                ? ((failed + abandoned + delivered) / delivered).toFixed(2)
                : 0;
              return {
                id:          item.id || idx + 1,
                date:        item.date || moment().format("DD/MM/YYYY"),
                activityKey: item.activityKey || item.activity_key || "-",
                channel:     item.channel || "-",
                sent:        item.sent || item.totalSent || 0,
                delivered,
                failed,
                abandoned,
                rate,
                _original:   item,
              };
            });
            setData(processed);
          } else {
            setData([]);
          }
        }
      },
      userDetails.jwttoken,
    );
  }, [userDetails.jwttoken, navigate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const renderCell = (item, field) => {
    const value = item[field.key];
 if (field.key === "channel") {
  return (
    <span className={`badge ${CHANNEL_BADGE[value] || "badge-secondary"}`}>
      {value}
    </span>
  );
}
    if (field.key === "activityKey") {
      if (!value || value === "-") return <span>-</span>;
      const tooltipId = `ds-actkey-${item.id}`;
      return (
        <>
          <span data-tooltip-id={tooltipId} className="description-trigger">
            {String(value)}
          </span>
          <Tooltip id={tooltipId} content={String(value)} place="top" />
        </>
      );
    }
    if (field.key === "delivered") return <span className="text-success">{value}</span>;
    if (field.key === "failed")    return <span className="text-danger">{value}</span>;
    if (field.key === "abandoned") return <span className="text-warning">{value}</span>;
    if (field.key === "rate")      return <span className="text-info fw-bold">{value}</span>;
    return <span>{value}</span>;
  };

  return (
    <>
      <div className="c-hr"></div>

      <div className="l-row">
        <div className="l-col-100">
          <div className="c-hr u-margin-bottom-0"></div>

          <div className="notification-list-table">
            <div className="c-list-entry c-list-entry__header align-items-center">
              {COLUMNS.map((col) => (
                <div key={col.key} className={col.class}>
                  <span style={{ opacity: 0.6 }}>{col.label}</span>
                </div>
              ))}
            </div>

            <div>
              {isLoading ? (
                <div className="u-text-align-center u-margin-top-bottom-m">
                  Loading...
                </div>
              ) : data.length > 0 ? (
                data.map((item, index) => (
                  <div className="c-list-entry align-items-center" key={index}>
                    {COLUMNS.map((field) => (
                      <div key={field.key} className={field.class}>
                        {renderCell(item, field)}
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="u-text-align-center u-margin-top-bottom-m u-color-red">
                  No data found.
                </div>
              )}
            </div>
          </div>

          <div className="c-hr u-margin-bottom-0"></div>
        </div>
        <div style={{ clear: "both" }}></div>
      </div>
    </>
  );
};

DailySummaryTab.propTypes = {
  userDetails: PropTypes.object.isRequired,
  navigate:    PropTypes.func.isRequired,
};

export default DailySummaryTab;
